import React, { Component } from 'react';
import { Container, Button, Form, Label, Input, Row, Col, Card } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import Tarjeta from '../../Componentes/Cards/registrosCard'
import { toast } from 'react-toastify'

export default class AdminUsuarios extends Component {
    constructor() {
        super();
        this.state = {
            usuarios: [],
            registros: [],
            select_usuario: null,
            select_accion: null,
            select_dia: null,
            select_mes: null,
            select_año: null,
        }
        this.setValueNumber = this.setValueNumber.bind(this)
        this.buscar = this.buscar.bind(this)
        this.setValue = this.setValue.bind(this)
        this.listaAño = this.listaAño.bind(this)
        this.borrarTodo = this.borrarTodo.bind(this)
        this.getMes = this.getMes.bind(this)
    }

    componentDidMount() {
        Fetch('/api/getRegistroActividad', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ registros: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        break;

                    default:
                        break;
                }
            })

        Fetch('/api/getUsuariosLista', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ usuarios: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        break;

                    default:
                        break;
                }
            })
    }

    setValueNumber(field, ev) {
        this.setState({ [field]: Number(ev.target.value) })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    listaAño(){
    var render = [];
        for(var x=2020;x<new Date().getFullYear()+1;x++){
            render.push(<option>{x}</option>)
        }
    return render;
    }

    borrarTodo(){
        console.log(this.state);
        this.setState({
            select_usuario: '',
            select_accion: '',
            select_dia: '',
            select_mes: '',
            select_año: ''
        })
    }

    getMes(mes){
        switch(mes){
            case 'Enero':
            return 1;

            case 'Febrero':
            return 2;

            case 'Marzo':
            return 3;

            case 'Abril':
            return 4;

            case 'Mayo':
            return 5;

            case 'Junio':
            return 6;

            case 'Julio':
            return 7;

            case 'Agosto':
            return 8;

            case 'Septiembre':
            return 9;

            case 'Octubre':
            return 10;

            case 'Noviembre':
            return 11;

            case 'Diciembre':
            return 12;

            default:
                break;
        }
    }

    buscar(){
        const { select_usuario, select_accion, select_dia, select_mes, select_año} = this.state
        
        if(select_dia !== '' || select_mes !== '' || select_año !== ''){
            if(select_dia !== '' && select_mes !== '' && select_año !== ''){
                Fetch('/api/consultarRegistroActividad', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ select_usuario, select_accion, select_dia, select_mes: this.getMes(select_mes), select_año })
                })
                    .then(response => {
                        this.setState({ registros: response.data })
                    })
                    .catch(err => {
                        switch (err.status) {

                            case 600:
                                console.log('Error inesperado')
                                break;

                            case 605:
                                this.setState({ registros: [] })
                                break;

                            default:
                                break;
                        }
                })
            }else{
                toast.error('Para buscar fechas todos los campos deben ser seleccionados')
                return this;
            }
        }else{
            Fetch('/api/consultarRegistroActividad', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ select_usuario, select_accion })
            })
                .then(response => {
                    this.setState({ registros: response.data })
                })
                .catch(err => {
                    switch (err.status) {

                        case 600:
                            console.log('Error inesperado')
                            break;

                        case 605:
                            this.setState({ registros: [] })
                            break;

                        default:
                            break;
                    }
                })
        }
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light col-sm-2">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Registro de actividad</h1>
                                        <p className="lead">Esta seccion permite visualizar los cambios realizados por el usuario</p>
                                        <hr className="my-1" />
                                    </Card>

                                    <Card className="p-4 mb-3">
                                        <Form>
                                            <Row>
                                                <Col className="col-3">
                                                        <Label>Usuario</Label>
                                                        <Input type="select" name="usuario" className="col-12" onChange={this.setValue.bind(this, "select_usuario")} value={this.state.select_usuario}>
                                                            <option> </option>
                                                            {this.state.usuarios.map(elem => (
                                                                <option>{elem.usuario}</option>
                                                            ))}
                                                        </Input>
                                                </Col>

                                                <Col className="col-5">
                                                        <Label>Accion</Label>
                                                        <Input type="select" name="usuario" className="col-11" onChange={this.setValue.bind(this, "select_accion")} value={this.state.select_accion}>
                                                            <option> </option>
                                                            <option>Inició sesion</option>
                                                            <option>Inició sesion por primera vez</option>
                                                            <option>Registro de usuario</option>
                                                            <option>Registró al usuario</option>
                                                            <option>Realizó busqueda de usuarios</option>
                                                            <option>Realizó busqueda de usuarios no autorizados</option>
                                                            <option>Eliminó la cuenta de usuario</option>
                                                            <option>Finalizó el procedimiento de primer inicio de sesion</option>
                                                            <option>Actualizó el estado del usuario</option>
                                                            <option>Actualizó los datos del usuarios</option>
                                                            <option>Actualizó el nombre del usuario</option>
                                                            <option>Actualizó el apellido paterno del usuario</option>
                                                            <option>Actualizó el apellido materno del usuario</option>
                                                            <option>Actualizó el nombre de usuario a</option>
                                                            <option>Actualizó contraseña del usuario</option>
                                                            <option>Agregó Modulo</option>
                                                            <option>Realizó busqueda en Modulos</option>
                                                            <option>Eliminó Modulo</option>
                                                            <option>Actualizó Modulo</option>
                                                            <option>Agregó al listado de documentos</option>
                                                            <option>Consultó el listado de documentos registrados</option>
                                                            <option>Eliminó documento</option>
                                                            <option>Actualizó documento</option>
                                                            <option>Agregó estudiante</option>
                                                            <option>Realizó busqueda de estudiantes</option>
                                                            <option>Actualizó estudiante</option>
                                                            <option>Eliminó estudiante</option>
                                                            <option>Realizó una consulta</option>
                                                            <option>Realizó una consulta al estudiante</option>
                                                            <option>Agregó Documento</option>
                                                            <option>Realizó busqueda de documentos en seccion consulta</option>
                                                            <option>Realizó busqueda de documentos sin validar</option>
                                                            <option>Autorizó documento</option>
                                                            <option>Rechazó documento</option>
                                                            <option>Consultó el listado de documentos registrados</option>
                                                            <option>Actualizó documento</option>
                                                        </Input>
                                                </Col>

                                                <Col className="col-4">
                                                        <Label>Fecha</Label>
                                                        <Row>
                                                            <Input type="select" name="dia" className="col-3" onChange={this.setValue.bind(this, "select_dia")} value={this.state.select_dia}>
                                                                <option>Dia</option>
                                                                <option>01</option>
                                                                <option>02</option>
                                                                <option>03</option>
                                                                <option>04</option>
                                                                <option>05</option>
                                                                <option>06</option>
                                                                <option>07</option>
                                                                <option>08</option>
                                                                <option>09</option>
                                                                <option>10</option>
                                                                <option>11</option>
                                                                <option>12</option>
                                                                <option>13</option>
                                                                <option>14</option>
                                                                <option>15</option>
                                                                <option>16</option>
                                                                <option>17</option>
                                                                <option>18</option>
                                                                <option>19</option>
                                                                <option>20</option>
                                                                <option>21</option>
                                                                <option>22</option>
                                                                <option>23</option>
                                                                <option>24</option>
                                                                <option>25</option>
                                                                <option>26</option>
                                                                <option>27</option>
                                                                <option>28</option>
                                                                <option>29</option>
                                                                <option>30</option>
                                                                <option>31</option>
                                                            </Input>
                                                            <Input type="select" name="mes" className="col-4" onChange={this.setValue.bind(this, "select_mes")} value={this.state.select_mes}>
                                                                <option>Mes</option>
                                                                <option>Enero</option>
                                                                <option>Febrero</option>
                                                                <option>Marzo</option>
                                                                <option>Abril</option>
                                                                <option>Mayo</option>
                                                                <option>Junio</option>
                                                                <option>Julio</option>
                                                                <option>Agosto</option>
                                                                <option>Septiembre</option>
                                                                <option>Octubre</option>
                                                                <option>Noviembre</option>
                                                                <option>Diciembre</option>
                                                            </Input>
                                                            <Input type="select" name="año" className="col-3" onChange={this.setValue.bind(this, "select_año")} value={this.state.select_año}>
                                                                <option>Año</option>
                                                                {this.listaAño().map(elem=>(elem))}
                                                            </Input>
                                                        </Row>
                                                </Col>
                                            </Row>    

                                            <Row>
                                                <Col>
                                                
                                                </Col>
                                            </Row>                                            
                                        </Form>

                                        <div id="boton" className="mt-3 text-center">
                                            <Row>
                                                <Col className="text-left">
                                                    <Button className="w-25 bg-info mr-3" onClick={this.buscar}>Buscar</Button>
                                                    <Button className="w-25 bg-dark ml-3" onClick={this.borrarTodo}>Limpiar</Button>
                                                </Col><Col />
                                            </Row>
                                        </div>
                                    </Card>

                                    <Row>
                                        <Tarjeta encabezado={true} />
                                        {this.state.registros.length > 0 ? this.state.registros.map((index) => (<Tarjeta usuario={index.usuario} accion={index.accion} fechaHora={index.fechaHora} />)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>}
                                    </Row>

                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}

